// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datatable-targets .p-paginator .p-paginator-current {
  margin-left: auto;
}

.datatable-targets .p-progressbar {
  height: .5rem;
  background-color: #D8DADC;
}

.datatable-targets .p-progressbar .p-progressbar-value {
  background-color: #607D8B;
}

.datatable-targets .table-header {
  display: flex;
  justify-content: space-between;
}

.datatable-targets .table-header .heading {
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.datatable-targets .p-datepicker {
  min-width: 25rem;
}

.datatable-targets .p-datepicker td {
  font-weight: 400;
}

.datatable-targets .p-datatable.p-datatable-header {
  padding: 1rem;
  text-align: left;
  font-size: 2.0rem;
}

.datatable-targets .p-datatable.p-paginator {
  padding: 1rem;
}

.datatable-targets .p-datatable.p-datatable-thead > tr > th {
  text-align: left;
}

.datatable-targets .p-datatable.p-datatable-tbody > tr > td {
  cursor: auto;
}

.datatable-targets .p-datatable.p-dropdown-label:not(.p-placeholder) {
  text-transform: uppercase;
}

.datatable-targets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}



.datatable-targets .narrow-column {
  width: 200px !important;
}
.datatable-targets .p-inputtext {
  font-size : 0.8rem;
}

@media screen and (max-width: 960px) {
  .datatable-targets .p-datatable.p-datatable-thead > tr > th,
  .datatable-targets .p-datatable.p-datatable-tfoot > tr > td {
      display: none !important;
  }

  .datatable-targets .p-datatable.p-datatable-tbody > tr {
      border-bottom: 1px solid var(--layer-2);
  }

  .datatable-targets .p-datatable.p-datatable-tbody > tr > td {
      text-align: left;
      display: block;
      border: 0 none !important;
      width: 100% !important;
      float: left;
      clear: left;
      border: 0 none;
  }

  .datatable-targets .p-datatable.p-datatable-tbody > tr > td .p-column-title {
      padding: .4rem;
      min-width: 30%;
      display: inline-block;
      margin: -.4rem 1rem -.4rem -.4rem;
      font-weight: bold;
  }

  .datatable-targets .p-datatable.p-datatable-tbody > tr > td .p-progressbar {
      margin-top: 0rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/scene-d/Target/TargetDash/TargetDashTable/TargetDashDataTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;;MAEI,wBAAwB;EAC5B;;EAEA;MACI,uCAAuC;EAC3C;;EAEA;MACI,gBAAgB;MAChB,cAAc;MACd,yBAAyB;MACzB,sBAAsB;MACtB,WAAW;MACX,WAAW;MACX,cAAc;EAClB;;EAEA;MACI,cAAc;MACd,cAAc;MACd,qBAAqB;MACrB,iCAAiC;MACjC,iBAAiB;EACrB;;EAEA;MACI,gBAAgB;EACpB;AACF","sourcesContent":[".datatable-targets .p-paginator .p-paginator-current {\n  margin-left: auto;\n}\n\n.datatable-targets .p-progressbar {\n  height: .5rem;\n  background-color: #D8DADC;\n}\n\n.datatable-targets .p-progressbar .p-progressbar-value {\n  background-color: #607D8B;\n}\n\n.datatable-targets .table-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.datatable-targets .table-header .heading {\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.datatable-targets .p-datepicker {\n  min-width: 25rem;\n}\n\n.datatable-targets .p-datepicker td {\n  font-weight: 400;\n}\n\n.datatable-targets .p-datatable.p-datatable-header {\n  padding: 1rem;\n  text-align: left;\n  font-size: 2.0rem;\n}\n\n.datatable-targets .p-datatable.p-paginator {\n  padding: 1rem;\n}\n\n.datatable-targets .p-datatable.p-datatable-thead > tr > th {\n  text-align: left;\n}\n\n.datatable-targets .p-datatable.p-datatable-tbody > tr > td {\n  cursor: auto;\n}\n\n.datatable-targets .p-datatable.p-dropdown-label:not(.p-placeholder) {\n  text-transform: uppercase;\n}\n\n.datatable-targets .p-datatable-tbody > tr > td .p-column-title {\n  display: none;\n}\n\n\n\n.datatable-targets .narrow-column {\n  width: 200px !important;\n}\n.datatable-targets .p-inputtext {\n  font-size : 0.8rem;\n}\n\n@media screen and (max-width: 960px) {\n  .datatable-targets .p-datatable.p-datatable-thead > tr > th,\n  .datatable-targets .p-datatable.p-datatable-tfoot > tr > td {\n      display: none !important;\n  }\n\n  .datatable-targets .p-datatable.p-datatable-tbody > tr {\n      border-bottom: 1px solid var(--layer-2);\n  }\n\n  .datatable-targets .p-datatable.p-datatable-tbody > tr > td {\n      text-align: left;\n      display: block;\n      border: 0 none !important;\n      width: 100% !important;\n      float: left;\n      clear: left;\n      border: 0 none;\n  }\n\n  .datatable-targets .p-datatable.p-datatable-tbody > tr > td .p-column-title {\n      padding: .4rem;\n      min-width: 30%;\n      display: inline-block;\n      margin: -.4rem 1rem -.4rem -.4rem;\n      font-weight: bold;\n  }\n\n  .datatable-targets .p-datatable.p-datatable-tbody > tr > td .p-progressbar {\n      margin-top: 0rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
